<template>
  <v-menu
    left
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <event-item-create-update-dialog
        :event-id="eventItem.eventId"
        :event-item="eventItem"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on"
            @click.stop=""
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon
                  left
                  small
                >
                  edit
                </v-icon>
                Edit
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </event-item-create-update-dialog>

      <v-list-item @click.stop="confirmDelete = true">
        <v-list-item-content>
          <v-list-item-title>
            <v-icon
              left
              small
              color="error"
            >
              delete
            </v-icon>
            <span class="error--text">Delete</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <confirm-action
      :model="confirmDelete"
      :color="'error'"
      :title="'Delete Alert Event Item'"
      :description="'Are you sure you want to delete this alert event item?<br /><br />Alerts that have already been created will not be removed.'"
      :action-text="'Delete'"
      @cancel="confirmDelete = false"
      @confirmed="confirmed"
    />
  </v-menu>
</template>
<script>
import { mapActions } from 'vuex'
import EventItemCreateUpdateDialog from "../../EventItem/EventItemCreateUpdateDialog"
import ConfirmAction from "../../Common/ConfirmAction"

export default {
  components: {
    EventItemCreateUpdateDialog,
    ConfirmAction
  },
  props: {
    eventItem: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      confirmDelete: false
    }
  },
  methods: {
    ...mapActions([ 'deleteEventItems' ]),
    async confirmed() {
      const payload = [ this.eventItem.id ]
      await this.deleteEventItems(payload)
      this.confirmDelete = false
    }
  }
}
</script>
